import actions from "./actions";

const {FETCH_SUBJECTIVE_ATTENDANCE, FETCH_SUBJECTIVE_ATTENDANCE_RESET, FETCH_SUBJECTIVE_ATTENDANCE_REPORTS, FETCH_SUBJECTIVE_ATTENDANCE_REPORTS_RESET} = actions;
const initState = {
    subjectiveAttendance: [],
    subjectiveAttendanceReports: [],
};

const SubjectiveAttendanceReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_SUBJECTIVE_ATTENDANCE:
            return {
                ...state,
                subjectiveAttendance: data
            }
        case FETCH_SUBJECTIVE_ATTENDANCE_REPORTS:
            return {
                ...state,
                subjectiveAttendanceReports: data
            }
        case FETCH_SUBJECTIVE_ATTENDANCE_RESET:
            return {
                ...state,
                subjectiveAttendance: initState.subjectiveAttendance,
            };
        case FETCH_SUBJECTIVE_ATTENDANCE_REPORTS_RESET:
            return {
                ...state,
                subjectiveAttendanceReports: initState.subjectiveAttendanceReports,
            };
        default:
            return state;
    }
}

export default SubjectiveAttendanceReducer;
